import { useMount } from 'ahooks';
import { computed, observable } from 'mobx';
import { noop } from '@src/utils/common-util';
import { autobind } from 'core-decorators';
import Cookie from '@src/utils/cookie';

import CookieSettingModalStore from '../cookie-setting-modal/store';
import { useEffect, useRef } from 'react';
import debounce from 'lodash.debounce';

const $ = window.$;

export const COOKIE_FLAG = 'cookie_flag';

class CookieTipsModalStore {
  onClose = noop;
  @observable isShow = false;
  cookieSettingModalStore = new CookieSettingModalStore();

  constructor({ ...rest } = {}) {
    Object.assign(this, rest);
  }

  /**
   * 直接打开settings
   * @type {boolean}
   */
  @observable isDirectToSettingModal = false;

  /**
   * 设置
   * @type {boolean}
   */
  @observable showCookieSettings = false;

  @observable cookieFlagInfo;

  /**
   * 是否允许cookies
   * @type {{analytics: boolean, necessary: boolean}}
   */
  @observable
  acceptCookies = {
    necessary: true,
    analytics: false
  };

  /**
   * 标记cookie是否已经选择
   */
  @autobind
  setCookieFlag(status = { necessary: 1, analytics: 0 }) {
    Cookie.set(COOKIE_FLAG, JSON.stringify(status), { expires: 90 });
    // Cookie.set(COOKIE_FLAG, JSON.stringify(status), { expires: new Date(new Date().getTime() + 5 * 60 * 1000) });
    this.acceptCookies.analytics = status.analytics;
    this.acceptCookies.necessary = status.necessary;
  }

  @autobind
  getCookieFlag() {
    this.cookieFlagInfo = Cookie.get(COOKIE_FLAG);
  }

  /**
   * 点击"接受所有的cookie"按钮时回调
   */
  @autobind
  acceptOptionalCookies() {
    this.setCookieFlag({ necessary: 1, analytics: 1 });
    this.onClose();
  }

  /**
   * 是否存在CookieFlag
   * @returns {boolean}
   */
  @computed
  get hasCookieFlag() {
    return !!this.cookieFlagInfo;
  }

  @autobind
  onCookieSettingShowClick() {
    this.showCookieSettings = true;
  }

  /**
   * 点击"拒绝可选cookie"按钮时回调
   */
  @autobind
  rejectOptionalCookies() {
    this.setCookieFlag({ necessary: 1, analytics: 0 });
    this.onClose();
  }

  /**
   * 退出所有弹窗
   */
  exitAllModal() {
    this.onClose();
    this.showCookieSettings = false;
  }

  /**
   * 仅关闭设置弹窗
   */
  exitSettingModal() {
    this.showCookieSettings = false;
  }

  @autobind
  onCookieSettingModalClose() {
    if (this.isDirectToSettingModal) {
      this.onClose();
    } else {
      this.showCookieSettings = false;
    }
  }

  setModalBodyHeight = debounce(() => {
    $(this.rootRef.current).css('height', `${window.innerHeight}PX`);
  }, 100);

  use() {
    this.rootRef = useRef(null);
    useMount(() => {
      this.isShow = true;
      this.cookieSettingModalStore.acceptOptionalCookies = this.acceptOptionalCookies;
      this.cookieSettingModalStore.rejectOptionalCookies = this.rejectOptionalCookies;
      this.getCookieFlag();
      this.setModalBodyHeight();
    });
    useEffect(() => {
      window.addEventListener('resize', () => this.setModalBodyHeight());
      return () => window.removeEventListener('resize', () => this.setModalBodyHeight());
    }, []);
    useEffect(
      () => {
        if (this.isDirectToSettingModal) {
          this.showCookieSettings = true;
        }
      },
      [this.isDirectToSettingModal]
    );
    useEffect(
      () => {
        this.cookieSettingModalStore.acceptCookies.necessary = this.acceptCookies.necessary;
        this.cookieSettingModalStore.acceptCookies.analytics = this.acceptCookies.analytics;
      },
      [this.acceptCookies.necessary, this.acceptCookies.analytics]
    );
  }
}

export default CookieTipsModalStore;
